export default `
  mutation($userId: String!, $pin: String!){
    changePin(userId: $userId, pin: $pin) {
      message
      code
    }
  }
`
